import type { HTMLAttributes } from "react";

import { AnimatedBackground, Root } from "./styles";

export type PendingProps = HTMLAttributes<HTMLDivElement> & {
  /**
   * Whether the entity is animated
   */
  isAnimated?: boolean;
};

/**
 * An element showing a loading status.
 */
export function Pending({ isAnimated, ...rest }: PendingProps): JSX.Element {
  return (
    <Root data-testid={Pending.name} {...rest}>
      <AnimatedBackground
        isAnimated={isAnimated}
        data-testid={`${Pending.name}-AnimatedBackground`}
      />
    </Root>
  );
}
